import { useState } from "react";
import { IconButton, Menu, MenuItem, Typography } from "@mui/material";
import SettingsIcon from '@mui/icons-material/Settings';
import DownloadIcon from '@mui/icons-material/Download';
import MenuIcon from '@mui/icons-material/Menu';

import { IMainMenuItem } from "../types";

import toolbarStyles from "../Toolbar.module.css";


interface MainMenuProps {
    onSettings: () => void;
    onDownload: () => void;
    canDownload: boolean;
};

const MainMenu = (props: MainMenuProps): JSX.Element => {

    const options: IMainMenuItem[] = [
        { 
            id: "download", 
            icon: <DownloadIcon fontSize="large" />, 
            name: "Download Map Data", 
            description: 'Download map data to your device for offline use...', 
            canShow: props.canDownload,
            onClick: props.onDownload
        },
        { 
            id: "settings", 
            icon: <SettingsIcon fontSize="large" />, 
            name: "Settings", 
            description: 'Change application settings...', 
            canShow: true,
            onClick: props.onSettings
        }
    ];

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleItemClick = (item: IMainMenuItem) => {
        handleClose();
        item.onClick();
    };


    return (
        <>
            <IconButton 
                aria-label="Menu options..."
                id="mainMenuButton"
                aria-controls={open ? 'mainMenu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleClick}
                color="inherit" 
                className={toolbarStyles.secondary_button}
            >
                <MenuIcon />
            </IconButton>

            <Menu
                id="mainMenu"
                MenuListProps={{
                    'aria-labelledby': 'mainMenuButton',
                }}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "bottom", horizontal: "center" }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                    paper: {
                        sx: { minWidth: { xs: 'calc(100vw - 30px)', sm: '50%', md: '300px' } }
                    },
                }}
            >
            {options.filter(item => item.canShow === true).map((item) => (
                <MenuItem 
                    key={item.id} 
                    onClick={() => handleItemClick(item)} 
                    title={item.description} 
                >
                    {item.icon}
                    <Typography className={toolbarStyles.main_menu_item_name}>{item.name}</Typography>
                </MenuItem>
            ))}
            </Menu>
        </>
    );
};

export default MainMenu;